import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { faArrowLeft } from "@fortawesome/fontawesome-free-solid";
import Footer from "../components/footer/Footer";
import { VscDebugBreakpointLog } from "react-icons/vsc";
// import { faSquareCheck, faCheck } from "@fortawesome/free-solid-svg-icons";

const PrivacyPolicy = () => {
  return (
    <div className="bg-black pb-20">
      {/* header */}
      <Navbar />

      <div className="mt-14 px-5 sm:px-10 xl:px-16 2xl:px-32 w-min text-white">
        <Link
          to="/login"
          className="bg-slate-900 border border-slate-800 rounded-full p-2"
        >
          <FontAwesomeIcon
            icon={faArrowLeft}
            className="w-5 h-5 text-white/800 cursor-pointer pt-0.5"
          />
        </Link>
      </div>

      <div className="cardBorder1 borderFN mx-3 xs:mx-5 sm:mx-10 xl:mx-16 2xl:mx-32 mt-5 font-body ">
        <div id="grad" className="rounded-lg">
          <div className="font-body">
            <div className="bg-gradient-to-r from-[#0c0c0c] via-[#444444] to-[#0c0c0c] rounded-t-xl">
              <h2 className="text-white text-xl text-left px-5 lg:px-10 py-2.5">
                Privacy Policy
              </h2>
            </div>
            <h2 className="font-body text-lg sm:text-xl md:text-2xl lg:text-3xl font-normal text-center text-slate-100 px-5 md:px-20 xl:px-44 py-10 leading-10">
              Your Privacy for us is of Utmost Importance
            </h2>
            <div className="px-5 lg:px-10 text-slate-100">
              {/* <h2 className="font-body text-xl lg:text-2xl font-semibold text-white pb-6">
                I. Scope
              </h2> */}
              <h2 className="font-body py-1 text-white">
                Drivado Transfers Pvt Ltd under its brand Tracklimo including
                its affiliates is committed to respect your privacy and to
                comply with applicable data protection and privacy laws. This
                privacy policy (“Policy”) describes how we collect and use
                personal data where TRACKLIMO is the data controller or where we
                refer to the applicability of this Policy. This Policy does not
                apply to the processing of personal data that we carry out on
                behalf of our customers for the purpose of service provisioning.
                Such processing is subject to the terms and conditions
                applicable to the respective business offering. “Personal data”
                means information relating to you or another identifiable
                individual.
                <br />
                <br />
                We will give you additional privacy information that is specific
                to a product or service in Supplements to this Policy and other
                notices you may see while using our products or services. If
                there is a difference between such notices and this Policy, the
                notices should be considered first.
                <br />
                <br />
                Software on your device may access your information. Our
                products or services may contain links to, or may be embedded
                within, other companies’ websites and services that have privacy
                policies of their own. Where our products or services are
                embedded to products and services of our customers, we require
                our customers to provide necessary transparency to you. This
                might include linking to this Policy and the relevant
                Supplements, or providing the transparency in integrated and
                embedded notices which identify us as the service provider or
                controller.
                <br />
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  If you do not agree with this Policy, do not use our products
                  and services or provide TRACKLIMO with your personal data.
                </h2>
              </h2>

              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                I. What information do we process?
              </h2>
              <h2 className="font-body py-1">
                When you create an account, make a purchase, use or register for
                our services participate in research or campaigns or otherwise
                interact with us, we may ask for information such as your name,
                email address, phone number, street address, user names and
                passwords, feedback, information relating to your devices, age,
                salutation, and language, bank account number, credit card
                details and other such financial information. We also maintain
                records of your consents, preferences and settings relating to,
                for example, location data, marketing and sharing of personal
                data. This includes following categories:
                <br />
              </h2>

              <div className="ml-10">
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  1. Product and service activations and usage
                </h2>

                <h2 className="font-body py-1">
                  TRACKLIMO products and services may require electronic
                  activation, where your device and application type, as well as
                  unique device, application, network and subscription
                  identifiers are sent to TRACKLIMO.
                  <br />
                  <br />
                  Additionally, our applications may contact our servers
                  periodically, for example to check for updates or to send us
                  information relating to service usage.
                </h2>
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  2. Logs and online usage information
                </h2>
                <h2 className="font-body py-1">
                  When you access our services online, our web servers
                  automatically create records of your visit. These records
                  typically include IP-address, access times, the sites linked
                  from, pages visited, the links and features used, the content
                  viewed or requested, browser or application type, language and
                  other such information. See also our{" "}
                  <Link
                    to="/CookiePolicy"
                    className="text-blue-500 hover:underline"
                  >
                    Cookie policy
                  </Link>
                  .
                </h2>
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  3. Service improvement and research programs
                </h2>

                <h2 className="font-body py-1">
                  We may invite you to join voluntary product and service
                  improvement or research programs where detailed information is
                  collected. See Supplements to this Policy for more details.
                </h2>
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  4. Your transactions with us
                </h2>

                <h2 className="font-body py-1">
                  We maintain records of your purchases, downloads, the content
                  you have provided us with, your requests, agreements between
                  you and TRACKLIMO, the products and services provided to you,
                  payment and delivery details, your contacts and communications
                  and other interactions with us. We may, in accordance with
                  applicable law, record your communication with our customer
                  care or with other such contact points.
                </h2>

                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  5. Positioning and Location data
                </h2>

                <h2 className="font-body py-1">
                  Location-based services establish location through the use of
                  satellite, mobile, Wi-Fi, Bluetooth Low Energy (“BLE”) or
                  other network-based positioning methods. These technologies
                  may involve exchanging your location data and unique device
                  and mobile, Wi-Fi, Bluetooth, or other network related
                  identifiers with TRACKLIMO. Our products may operate on
                  multiple device platforms, applications and services which may
                  also collect your location data. We do not use this
                  information to identify you personally without your consent.
                  When you use our location-based services and features, for
                  example location-based search, navigation and routing, or
                  request for map data, your location data is sent to TRACKLIMO
                  to serve you with the right content, which may also include
                  location-based advertising.
                  <br />
                </h2>

                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  6. Information provided by partners
                </h2>

                <h2 className="font-body py-1">
                  We obtain information from industry partners and a variety of
                  other sources, including publicly available sources such as
                  business registries. We take appropriate measures to ensure
                  compliance with applicable laws including conducting vendor
                  due diligence, establishing a valid legal basis for the
                  transfer, and requiring or anonymization or other data
                  minimization treatment prior to disclosure of the data to us
                  in accordance with applicable laws and regulations.
                  <br />
                </h2>
              </div>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                II. Why do we process Personal Data?
              </h2>

              <h2 className="font-body py-1">
                TRACKLIMO may process your personal data for the following
                purposes. One or more purposes may apply simultaneously.
              </h2>
              <div className="ml-10">
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  1. Providing products and services
                </h2>
                <h2 className="font-body py-1">
                  We may use your personal data to provide you with our products
                  and services, to process your requests and perform related
                  transactions or as otherwise may be necessary to perform the
                  contract between you and TRACKLIMO, to ensure the
                  functionality and security of our products and services, as
                  well as to prevent and investigate fraud and other misuses.
                  <br />
                  <br />
                  Some services may require an account to help you manage your
                  content and preferences. Depending on the service, an account
                  creation may be either required or voluntary. Account creation
                  requires you to provide us with basic contact details about
                  yourself, such as name, email address, country of residence
                  and date of birth. You may also be able to voluntarily provide
                  more information about yourself while creating a profile, such
                  as a photo or avatar of your choice.
                </h2>
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  2. Developing and managing products and services
                </h2>
                <h2 className="font-body py-1">
                  We may use your personal data to develop and manage our
                  products, services, customer care, sales and marketing. We may
                  combine personal data collected in connection with your use of
                  a particular TRACKLIMO product and/or service with other
                  personal data we may have about you, unless such personal data
                  was collected for a purpose where the original purpose is
                  incompatible with this purpose.
                  <br />
                </h2>
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  3. Communicating with you
                </h2>
                <h2 className="font-body py-1">
                  We may use your personal data to communicate with you, for
                  example to inform you that our services have changed or to
                  send you critical alerts and other such notices relating to
                  our products and/or services and to contact you for customer
                  care related purposes.
                  <br />
                </h2>

                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  4. Marketing, advertising and making recommendations
                </h2>
                <h2 className="font-body py-1">
                  We may contact you to inform you of new products, services or
                  promotions we may offer and to conduct market research when we
                  have your consent or it is otherwise allowed. We may use your
                  personal data to personalize our offering and to provide you
                  with more relevant services, for example, to make
                  recommendations and to display customized content and
                  advertising in our services. This may include displaying
                  TRACKLIMO and third party content.
                  <br />
                </h2>
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  5. Compliance
                </h2>
                <h2 className="font-body py-1">
                  We may process your data to comply with legal obligations,
                  safeguard individuals’ vital interests and safety, protect our
                  rights or property.
                  <br />
                </h2>
              </div>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                III. What is our legal basis for processing your Personal Data?
              </h2>
              <h2 className="font-body py-1">
                Our legal basis for processing your personal data is dependent
                on the purpose for processing and may vary as described in the
                Supplement applicable to the product or service you are using.
                In general, we process your personal data under the following
                legal bases:
              </h2>
              <div className="ml-10">
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  1. Performance of a contract with you
                </h2>
                <h2 className="font-body py-1">
                  We process your personal data to perform our obligations under
                  the Service Terms applicable to the product or service you are
                  using, provided by us or our customers. Our Service Terms are
                  available at{" "}
                  <a
                    href="https://tracklimo.com/termsConditions"
                    className="text-blue-500 hover:underline"
                  >
                    https://tracklimo.com/termsConditions
                  </a>
                  .
                </h2>
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  2. Your consent
                </h2>
                <h2 className="font-body py-1">
                  We process your personal data if you have consented to the
                  processing activity. You may revoke your consent at any time.
                  Doing so will bar us from further processing of your personal
                  data based on your consent, but will not impact the lawfulness
                  of processing based on your consent before it was withdrawn.
                  Some of the features of our products and services might be
                  only available based on consent.
                </h2>
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  3. Legal obligations
                </h2>
                <h2 className="font-body py-1">
                  We process your personal data as needed to comply with laws
                  and regulations.
                </h2>
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  4. Legitimate interests
                </h2>
                <h2 className="font-body py-1">
                  We process your personal data to further our legitimate
                  interests, such as in connection with managing, developing,
                  testing, securing, and in limited circumstances marketing,
                  advertising, and making recommendations regarding our products
                  and services. Any such processing is conducted subject to
                  appropriate measures to protect your fundamental rights and
                  freedoms related to your personal data, and in any event will
                  be subject to the restrictions provided in this Policy.
                  Further information or specification of our legitimate
                  interests may be provided in relevant Supplements applicable
                  to the product or service.
                </h2>
              </div>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                IV. How long do we retain Personal Data?
              </h2>
              <h2 className="font-body py-1">
                We endeavour to only collect personal data that are necessary
                for the purposes for which they are collected, and to retain
                such data for no longer than is necessary for such purposes. The
                length of time personal data is retained, and criteria for
                determining that time, are dependent on the nature of the
                personal data and the purpose for which it was provided. For
                example, for your personal data related to managing your account
                (such as name, email address, and account content and
                preferences) are maintained for as long as they are retained by
                you within your account. Other data, such as records of your
                activity within the application, are typically maintained only
                for a short period before being anonymized or pseudonymized.
                Additional information may be provided in the Supplement
                applicable to the product or service you are using. You may
                contact the TRACKLIMO Privacy Office at{" "}
                <a
                  href="mailto:support@drivado.com"
                  className="text-blue-500 hover:underline"
                >
                  support@drivado.com
                </a>{" "}
                to obtain additional information about retention of your
                personal data.
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                V. Do we share Personal Data?
              </h2>
              <h2 className="font-body py-1">
                We do not sell, lease, rent or otherwise disclose your personal
                data to third parties unless otherwise stated below.
              </h2>
              <div className="ml-10">
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  1. Your consent and social sharing services
                </h2>
                <h2 className="font-body py-1">
                  We may share your personal data if we have your consent to do
                  so. Some services may allow you to share your personal data
                  with other users of the service or with other services and
                  their users. Please consider carefully before disclosing any
                  personal data or other information that might be accessible to
                  other users.
                </h2>
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  2. TRACKLIMO companies and authorized third parties
                </h2>
                <h2 className="font-body py-1">
                  We may share your personal data with other TRACKLIMO companies
                  or authorized third parties who process personal data for
                  TRACKLIMO for the purposes described in this Policy. This may
                  include for example billing through your network service
                  provider or otherwise, delivery of your purchases, providing
                  services including customer service, managing and analyzing
                  consumer data, credit checks, conducting research and managing
                  marketing and other such campaigns. When you purchase a
                  TRACKLIMO product from us with a network service provider
                  plan, we may need to exchange information with your network
                  service provider to provide you with such service.
                  <br />
                  <br />
                  We may conduct joint marketing and other communications with
                  our partners, for example your mobile operator. To avoid
                  duplicate or unnecessary communications and to tailor the
                  message to you we may need to match information that TRACKLIMO
                  has collected with information that the partner has collected
                  where this is permitted by law.
                  <br />
                  <br />
                  These authorized third parties are not permitted to use your
                  personal data for any other purposes. We bind them
                  contractually, require them to act consistently with this
                  Policy and to use appropriate security measures to protect
                  your personal data.
                </h2>
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  3. Mandatory disclosures
                </h2>
                <h2 className="font-body py-1">
                  We may be obligated by mandatory law to disclose your personal
                  data to certain authorities or other third parties, for
                  example, to law enforcement agencies in the countries where we
                  or third parties acting on our behalf operate. We may also
                  disclose and otherwise process your personal data in
                  accordance with applicable law to defend TRACKLIMO’s
                  legitimate interests, for example, in legal proceedings or in
                  connection with governmental requests and filings.
                </h2>
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  4. Mergers and Acquisitions
                </h2>
                <h2 className="font-body py-1">
                  If we decide to sell, buy, merge or otherwise reorganize our
                  businesses in certain countries, this may involve us
                  disclosing personal data to prospective or actual purchasers
                  and their advisers, or receiving personal data from sellers
                  and their advisers.
                </h2>
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  5. International transfers of personal data
                </h2>
                <h2 className="font-body py-1">
                  Our products and services may be provided using resources and
                  servers located in various countries around the world.
                  Therefore, your personal data may be transferred across
                  international borders outside the country where you use our
                  services, including to countries outside the European Economic
                  Area (EEA) or the United Kingdom that do not have laws
                  providing specific protection for personal data or that have
                  different legal rules on data protection, for example, the
                  United States of America. In such cases we ensure that there
                  is a legal basis for such a transfer and that adequate
                  protection for your personal data is provided as required by
                  applicable law, for example, by using standard contractual
                  clauses approved by the European Commission or relevant
                  authorities (where necessary) and by requiring the use of
                  other appropriate technical and organizational information
                  security measures. You may contact the TRACKLIMO Privacy
                  Office at{" "}
                  <a
                    href="mailto:support@drivado.com"
                    className="text-blue-500 hover:underline"
                  >
                    support@drivado.com
                  </a>{" "}
                  to obtain additional information about the safeguards we take
                  in connection with these transfers. A copy of the unchangeable
                  Standard Contractual Clauses adopted by the European
                  Commission can be accessed on the website of the European
                  Commission&nbsp;
                  <a
                    href="https://commission.europa.eu/"
                    className="text-blue-500 hover:underline"
                  >
                    https://commission.europa.eu/
                  </a>{" "}
                  The international data transfer agreement (IDTA) and the
                  international data transfer addendum to the European
                  Commission’s standard contractual clauses for international
                  data transfers (Addendum) or other transfer mechanisms as may
                  be adopted in the future can be found on the website of the
                  Information Commissioner's Office{" "}
                  <a
                    href="https://ico.org.uk/"
                    className="text-blue-500 hover:underline"
                  >
                    https://ico.org.uk/
                  </a>
                  .
                </h2>
              </div>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                VI. How do we address the privacy of children?
              </h2>
              <h2 className="font-body py-1">
                TRACKLIMO products and services are typically intended for
                general audiences. TRACKLIMO does not knowingly collect
                information of children without the consent of their parents or
                guardians. TRACKLIMO publishes safety guidelines for using
                internet services in our websites.
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                VII. How do we address Data Quality?
              </h2>
              <h2 className="font-body py-1">
                We take reasonable steps to keep the personal data we process
                accurate and to delete incorrect or unnecessary personal data.
                We encourage you to access your personal data through your
                account from time to time to ensure that it is up to date.
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                VIII. What steps are taken to safeguard Personal Data?
              </h2>
              <h2 className="font-body py-1">
                Privacy and security are key considerations in the creation and
                delivery of our products and services. We have assigned specific
                responsibilities to address privacy and security related
                matters. We enforce our internal policies and guidelines through
                an appropriate selection of activities, including proactive and
                reactive risk management, security and privacy engineering,
                training and assessments. We take appropriate steps to address
                online security, physical security, risk of data loss and other
                such risks taking into consideration the risk represented by the
                processing and the nature of the data being protected. Also, we
                limit access to our data bases containing personal data to
                authorized persons having a justified need to access such
                information.
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                IX. How do we use Cookies and Web Beacons?
              </h2>
              <h2 className="font-body py-1">
                TRACKLIMO uses cookies, web beacons and other similar
                technologies to operate and improve our websites and offerings.
                We also use cookies for personalization and to display ads. Some
                TRACKLIMO websites use third party advertising technologies,
                such as DoubleClick, to serve ads.
                <br />
                <br />
                Our domains may include third party elements that set cookies on
                behalf of a third party, for example relating to third party
                social network. Please visit our Cookie policy to find out more
                about how TRACKLIMO uses cookies and how you can disable cookies
                by browser settings or otherwise.
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                X. What are your rights?
              </h2>
              <h2 className="font-body py-1">
                <span className="font-body font-semibold">
                  You have the following rights with respect to your personal
                  data:
                </span>

                <div className="ml-10 my-6 space-y-2">
                  <div className="flex items-center space-x-3">
                    <VscDebugBreakpointLog />{" "}
                    <span>
                      to know what personal data we hold about you, and to
                      access it,
                    </span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <VscDebugBreakpointLog />{" "}
                    <span>
                      to have incomplete, incorrect, unnecessary or outdated
                      personal data updated,{" "}
                    </span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <VscDebugBreakpointLog />{" "}
                    <span>to request that your personal data be erased, </span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <VscDebugBreakpointLog />{" "}
                    <span>
                      to obtain a copy of your data in a machine-readable
                      format,{" "}
                    </span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <VscDebugBreakpointLog />{" "}
                    <span>
                      to withdraw a previously granted consent to the processing
                      of your data;
                    </span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <VscDebugBreakpointLog />{" "}
                    <span>
                      {" "}
                      to object to or restrict processing in certain
                      circumstances, such as where you believe the data is
                      inaccurate or the processing activity is unlawful.
                    </span>
                  </div>
                </div>
              </h2>
              <h2 className="font-body py-1">
                You have a right to unsubscribe from direct marketing messages
                and to request that we stop processing your personal data for
                direct marketing purposes or on other compelling legal grounds.
                However, if you opt-out from marketing and other communications
                from TRACKLIMO, critical alerts may still be sent to you. If you
                are located in a European Union member state or within the
                European Economic Area, you have the right to lodge a complaint
                about our data collection and processing activities with the
                supervisory authority concerned. You may exercise your rights by
                contacting us by mailing us to support@drivado.com or by
                managing your account and choices through available profile
                management tools on your device and our services. In some cases,
                especially if you wish us to delete or stop processing your
                personal data, this may also mean that we may not be able to
                continue to provide the services to you. Applicable data
                protection law may provide certain restrictions on the extent to
                which these rights may be exercised. If a restriction applies,
                we will respond to your request with an explanation of what
                action will be taken, to the extent required under applicable
                data protection law.
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                XI. Who is the controller of your Personal Data?
              </h2>
              <div className="ml-10">
                <h2 className="font-body py-1">
                  Drivado Transfers Pvt Ltd, P-3 New CIT Road, Kolkata 700073,
                  India, is the controller of your personal data.
                </h2>
                <br />

                <h2 className="font-body py-1">
                  In addition, the TRACKLIMO affiliate providing the product or
                  service may be a controller of your personal data. You may
                  find the identity of the controller and its contact details by
                  reviewing the terms and conditions of such a product or
                  service or by using contact information provided in the
                  applicable TRACKLIMO websites.
                  <br />
                  <br />
                  In matters pertaining to TRACKLIMO’s privacy practices you may
                  contact our Data Protection Officer at:
                  <br />
                  <br />
                  Drivado Transfers Pvt Ltd
                  <br />
                  c/o Privacy
                  <br />
                  P-3 New CIT Road <br />
                  4th Floor, Kolkata 700073
                  <br />
                  India
                  <br />
                  <br />
                  Email:{" "}
                  <a href="mailto:support@drivado.com">support@drivado.com</a>
                </h2>
                <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                  Changes to this Privacy Policy
                </h2>
                <h2 className="font-body py-1 pb-10">
                  TRACKLIMO may from time to time change this Policy or change,
                  modify or withdraw access to this site at any time with or
                  without notice. However, if this Policy is changed in a
                  material, adverse way, TRACKLIMO will post a notice advising
                  of such change at the beginning of this Policy and on this
                  site's home page for 30 days. We recommend that you re-visit
                  this Policy from time to time to learn of any such changes to
                  this Policy.
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-5 sm:px-10 xl:px-16 2xl:px-32">
        <Footer />
      </div>
    </div>
  );
};

export default PrivacyPolicy;
